import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCloudDownload"><Path fillRule="evenodd" clipRule="evenodd" d="M5.77996 8.12427C6.80396 5.70153 9.20241 4 12 4C15.5725 4 18.4969 6.77542 18.7344 10.2877C21.1392 10.5876 23 12.639 23 15.125C23 17.8174 20.8174 20 18.125 20H7C3.68629 20 1 17.3137 1 14C1 11.1041 3.05102 8.68825 5.77996 8.12427ZM11.25 8H12.75V14.1893L14.5 12.4393L15.5607 13.5L12 17.0607L8.43934 13.5L9.5 12.4393L11.25 14.1893V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudDownload;
